export type InAppBrowser = 'linkedin' | 'facebook' | 'instagram' | 'none';

/** A social app whose built-in browser opened the page. */
export type InAppBrowserApp = Exclude<InAppBrowser, 'none'>;

/**
 * Names the social app whose built-in browser opened the page, from its user
 * agent. Ad clicks inside these apps open in a webview, where Google blocks
 * sign-in and storage is separate from the phone's main browser.
 */
export const detectInAppBrowser = (userAgent: string): InAppBrowser => {
  if (/LinkedInApp/i.test(userAgent)) return 'linkedin';
  if (/Instagram/i.test(userAgent)) return 'instagram';
  if (/FBAN|FBAV|FB_IAB/i.test(userAgent)) return 'facebook';
  return 'none';
};
